import { createSlice } from '@reduxjs/toolkit';
import { deleteChannel, deleteChannelAction, deletePartner, deletePartnersChannel, editChannelAction, getAllPartners, getChannelActionById, getChannelActions, getChannelTypeTemplate, getChannelTypes, getFieldValue, getFlowSettings, getPartnerApi, getPartnersChannels, getTriggerFields, postChannelAction, saveChannels, savePartnerApi, savePartnerChannels, savePartners, updateFields, updateFieldsValue, updateFlowSetting,getCacheList, clearCache, clearAllCache } from '../thunks/adminSettingsThunk';
import { toast } from 'react-toastify';
import { getCompanyConfigurationByTag, postCompanyConfigurationAuto } from '../thunks/companyThunks';

const adminSettings = createSlice({
    name: 'adminSettings',
    initialState: {
        isLoading: true,
        error: null,
        triggerFields: { triggerFieldsData: [] },
        flowSettings: { flowSettingsData: [] },
        fileSetup: {
            isFileSetupLoading: true,
            fileSetupData: [],
            selectedPartner: [],
            fieldValueData: []
        },
        vendorSetup: {
            isChannelDeleted: 0,
            isPartnerChannelDeleted: 0,
            partnerDeleteCount: 0,
            isPartnerChannelAdded: 0,
            isPartnerDeleted: 0,
            isPartnerApiAdded: 0,
            channleTypes: [],
            availableChannels: [],
            partnerChannels: [],
            allPartners: [],
            channleTypeTemplates: [],
            selectedPartnerData: [],
            newPartnerChannel: [],
            newAPIKey: [],
            partnerApi: []
        },
        channelActions: {
            channelActionsData: [],
            currentPage: 1,
            pageSize: 10,
            totalRecordsFetch: 0,
            totalPages: 0,
            type: 'Create',
            showModal: false,
            channelActionDataById: {}
        },
        cacheSetting: {
            isCacheListLoading: true,
            isLoading: true,
            cacheList: [],
            componentNames: [],
            cacheTableData: []
        },
        companyConfig: []
    },
    reducers: {
        updateTriggerFieldsDataAction(state, action) {
            state.triggerFields.triggerFieldsData = action.payload;
        },
        updateFlowSettings(state, action) {
            state.flowSettings.flowSettingsData = action.payload;
        },
        updateSelectedPartner(state, action) {
            state.fileSetup.selectedPartner = action.payload;
        },
        updateFieldValueData(state, action) {
            if (action.payload.length !== 0) {
                state.fileSetup.fieldValueData = updatedFieldValueData(state, action);
            } else {
                return {
                    ...state,
                    fileSetup: {
                        ...state.fileSetup,
                        fieldValueData: []
                    }
                };
            }
            return state;
        },
        createPartnerChannel(state, action) {
            const {
                partnerId, channelId, channelName 
            } = action.payload;
            // Add the new channel to a new array
            const newChannel = {
                partnerId: partnerId,
                channelId: channelId,
                channelName: channelName
            };
            // Return the updated state with only the new channel
            return {
                ...state,
                vendorSetup: {
                    ...state.vendorSetup,
                    newPartnerChannel: [newChannel]
                }
            };
        },
        
        
        createSelectedPartnerData(state, action) {
            const { selectedPartners, partnerChannels } = action.payload;
            if (selectedPartners) {
                const updatedSelectedPartners = selectedPartners?.map((partner) => {
                    const channels = partnerChannels
                        .filter((channel) => channel.partner_id === partner.id)
                        .map((item) => item.campaign_type);
                    return {
                        ...partner,
                        campaign_type: channels
                    };
                });
                state.vendorSetup.selectedPartnerData = updatedSelectedPartners;
            }
        },
        createAPiKey(state, action) {
            const { partnerId, apiKey } = action.payload.payload;
            const index = state.vendorSetup.newAPIKey.findIndex(item => item.partnerId === partnerId);
            if (index !== -1) {
                state.vendorSetup.newAPIKey[index].apiKey = apiKey;
            } else {
                state.vendorSetup.newAPIKey.push({ partnerId: partnerId, apiKey: apiKey });
            }

        }, 
        setCurrentPage: (state, action) => {
            state.channelActions.currentPage = action.payload;
        },
        handleChannelActionModal: (state, action) =>{
            state.channelActions.type = action.payload === 'Edit' ? 'Edit' : 'Create';
            state.channelActions.channelActionDataById = {};
            state.channelActions.showModal =!state.channelActions.showModal;
        }, 
        createCacheTableData: (state, action ) => {
            const finalData = action.payload.filter((item) => item.size).map((item, index)=>{
                const value = item.key.replaceAll('$', ' ').split(' ');
                return {
                    key: item.key,
                    name: value[0],
                    startDate: value[2],
                    endDate: value[3],
                    reload_cache_path: item.reload_cache_path,
                    download_link: item.download_link
                };
            });
            state.cacheSetting.cacheTableData = finalData;
        }
    },
    extraReducers: (builder) =>{
        builder
            /* Trigger settings */
            .addCase(getTriggerFields.fulfilled, (state,action) => {
                state.triggerFields.triggerFieldsData = action.payload?.triggerFields;
                state.error = null;
                state.isLoading = false;
            })
            .addCase(getTriggerFields.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getTriggerFields.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(updateFields.fulfilled, (state,action) => {
                state.error = null;
                state.isLoading = false;
                if(action.payload?.status_code === 200){
                    toast.success(action.payload?.success);
                } else{
                    toast.error(action.payload);
                }
                
            })
            .addCase(updateFields.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(updateFields.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            /* Flow Settings */
            .addCase(getFlowSettings.fulfilled, (state,action) => {
                state.flowSettings.flowSettingsData = action.payload?.settings;
                state.error = null;
                state.isLoading = false;
            })
            .addCase(getFlowSettings.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getFlowSettings.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(updateFlowSetting.fulfilled, (state,action) => {
                state.error = null;
                state.isLoading = false;
                if(action?.payload?.status_code === 200){
                    toast.success('Flow setting updated successfully!');
                } else{
                    toast.error(action?.payload?.error?.value);
                }
            })
            .addCase(updateFlowSetting.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(updateFlowSetting.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })

            .addCase(getPartnersChannels.fulfilled, (state,action) => {
                state.fileSetup.fileSetupData = extractPartnerInfo(action.payload?.result);
                state.vendorSetup.partnerChannels = action.payload?.result;
                state.error = null;
                state.isLoading = false;
            })
            .addCase(getPartnersChannels.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getPartnersChannels.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(getFieldValue.fulfilled, (state,action) => {
                state.fileSetup.fieldValueData =action.payload?.types;
                state.error = null;
                state.isLoading = false;
            })
            .addCase(getFieldValue.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getFieldValue.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(updateFieldsValue.fulfilled, (state,action) => {
                state.error = null;
                state.isLoading = false;
                if(action?.payload?.status_code === 200){
                    toast.success(action?.payload?.success);
                } else{
                    toast.error(action?.payload?.error || 'Something went wrong, please try again later!');
                }
            })
            .addCase(updateFieldsValue.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(updateFieldsValue.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            /* Vendor setup */
            .addCase(getChannelTypes.fulfilled, (state,action) => {
                state.vendorSetup.channleTypes = channelTypeOptions(action.payload?.result || []);
                state.error = null;
                state.isLoading = false;
            })
            .addCase(getChannelTypes.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getChannelTypes.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(getAllPartners.fulfilled, (state,action) => {
                state.vendorSetup.allPartners = action.payload?.result;
                state.error = null;
                state.isLoading = false;
            })
            .addCase(getAllPartners.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getAllPartners.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(getChannelTypeTemplate.fulfilled, (state, action) => {
                state.vendorSetup.channleTypeTemplates = channelTypeTemplateOptions(action.payload?.result || []);
                state.error = null;
                state.isLoading = false;
            })
            .addCase(getChannelTypeTemplate.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getChannelTypeTemplate.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(deletePartnersChannel.fulfilled, (state, action) => {
                if(action.payload?.status_code === 200){
                    state.vendorSetup.isPartnerChannelDeleted += 1;
                    toast.success(action.payload?.status);
                } else{
                    toast.error(action.payload?.status);
                }
                state.isLoading = false;
            })
            .addCase(deletePartnersChannel.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(deletePartnersChannel.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(deleteChannel.fulfilled, (state, action) => {
                if(action.payload?.status_code === 200){
                    state.vendorSetup.isChannelDeleted+= 1;
                    toast.success(action.payload?.status);
                } else{
                    toast.error(action.payload?.status);
                }

                state.isLoading = false;
            })
            .addCase(deleteChannel.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(deleteChannel.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(saveChannels.fulfilled, (state, action) => {
                if(action.payload?.status_code === 200){
                    toast.success(action.payload?.status);
                } else{
                    toast.error(action.payload?.status);
                }
                state.isLoading = false;
            })
            .addCase(saveChannels.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(saveChannels.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(savePartners.fulfilled, (state, action) => {
                if(action.payload?.status_code === 200){
                    toast.success(action.payload?.status);
                } else{
                    toast.error(action.payload?.status);
                }
                state.isLoading = false;
            })
            .addCase(savePartners.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(savePartners.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(deletePartner.fulfilled, (state, action) => {
                if(action.payload?.status_code === 200){
                    state.vendorSetup.isPartnerDeleted+= 1;
                    toast.success(action.payload?.status);
                } else{
                    toast.error(action.payload?.status);
                }
                state.isLoading = false;
            })
            .addCase(deletePartner.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(deletePartner.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(getPartnerApi.fulfilled, (state, action) => {
                state.vendorSetup.partnerApi = getPartnerApiData(action.payload?.result);
                state.isLoading = false;
            })
            .addCase(getPartnerApi.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getPartnerApi.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(savePartnerApi.fulfilled, (state, action) => {
                if(action.payload?.status_code === 200){
                    state.vendorSetup.isPartnerApiAdded+= 1;
                    toast.success(action.payload?.status);
                } else{
                    toast.error(action.payload?.status);
                }
                
                state.isLoading = false;
            })
            .addCase(savePartnerApi.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(savePartnerApi.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(savePartnerChannels.fulfilled, (state, action) => {
                if(action.payload?.status_code === 200){
                    state.vendorSetup.isPartnerChannelAdded+=1;
                    toast.success(action.payload?.status);
                } else{
                    toast.error(action.payload?.status);
                }
                
                state.isLoading = false;
            })
            .addCase(savePartnerChannels.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(savePartnerChannels.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })

            /* channel Actions */
            .addCase(getChannelActions.fulfilled, (state,action) => {
                state.channelActions.totalPages = Math.ceil((action.payload.length ?? 0) / state.channelActions.pageSize);
                state.channelActions.channelActionsData = action.payload;
                state.error = null;
                state.isLoading = false;
            })
            .addCase(getChannelActions.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getChannelActions.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload.data;
                const error = action.payload.data;
                toast.error(Object.keys(error).includes('message') ? error.message : error);
            })
            .addCase(getChannelActionById.fulfilled, (state,action) => {
                state.channelActions.channelActionDataById = action.payload;
                state.error = null;
                state.isLoading = false;
            })
            .addCase(getChannelActionById.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getChannelActionById.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(deleteChannelAction.fulfilled, (state,action) => {
                state.error = null;
                state.isLoading = false;
                toast.success(action?.payload?.message);
            })
            .addCase(deleteChannelAction.pending, (state, action) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(deleteChannelAction.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(postChannelAction.fulfilled, (state,action) => {
                state.error = null;
                state.isLoading = false;
                if(!action.payload.error){
                    toast.success('Action created successfully.');
                }
            })
            .addCase(postChannelAction.pending, (state, action) => {
                state.error = null;
            })
            .addCase(postChannelAction.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload.message);
            })
            .addCase(editChannelAction.fulfilled, (state,action) => {
                state.error = null;
                state.isLoading = false;
                if(!action.payload.error){
                    toast.success('Action updated successfully.');
                }
            })
            .addCase(editChannelAction.pending, (state, action) => {
                state.error = null;
            })
            .addCase(editChannelAction.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload.message);
            })
            // Cache management
            .addCase(getCacheList.fulfilled, (state, action) => {
                state.cacheSetting.cacheList = action.payload;
                if(Object.keys(action.payload).length > 0){
                    state.cacheSetting.componentNames = Object.keys(action.payload);
                }
                state.cacheSetting.isCacheListLoading = false;
                
            })
            .addCase(getCacheList.pending, (state, action) => {
                state.cacheSetting.isCacheListLoading = true;
            })
            .addCase(getCacheList.rejected, (state, action) => {
                state.cacheSetting.isCacheListLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(clearCache.fulfilled, (state, action) => {
                state.cacheSetting.isLoading = false;
                toast.success(action?.payload?.message);
                
            })
            .addCase(clearCache.pending, (state, action) => {
                state.cacheSetting.isLoading = true;
            })
            .addCase(clearCache.rejected, (state, action) => {
                state.cacheSetting.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            })
            .addCase(getCompanyConfigurationByTag.fulfilled, (state, action) => {
                const data = action.payload?.config || [];
                state.companyConfig = data;
                state.isLoading = false;
            })
            .addCase(getCompanyConfigurationByTag.pending, (state, action) => {
                state.cacheSetting.isLoading = true;
            })
            .addCase(getCompanyConfigurationByTag.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(postCompanyConfigurationAuto.fulfilled, (state, action) => {
                if(action.payload?.status_code === 200){
                    toast.success(action?.payload?.message);
                }
                
                state.isLoading = false;
            })
            .addCase(postCompanyConfigurationAuto.pending, (state, action) => {
                state.cacheSetting.isLoading = true;
            })
            .addCase(postCompanyConfigurationAuto.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(clearAllCache.fulfilled, (state, action) => {
                state.cacheSetting.isLoading = false;
                toast.success(action?.payload?.message);
                
            })
            .addCase(clearAllCache.pending, (state, action) => {
                state.cacheSetting.isLoading = true;
            })
            .addCase(clearAllCache.rejected, (state, action) => {
                state.cacheSetting.isLoading = false;
                state.error = action.payload;
                toast.error(action.payload);
            });
    }
});

const extractPartnerInfo = (data=[]) => {
    if(Array.isArray(data) && data.length){
        const result = [];

        for (const item of data) {
            const partnerName = item.partner.name;
            const machineName = item.partner.machine_name;
            const { id } = item.partner;
    
            result.push({
                id: id, label: partnerName, value: machineName 
            });
        }
        const uniqueData = [...new Map(result.map(item => [item.id, item])).values()];
        return uniqueData;
    }
    return [];
};

const channelTypeTemplateOptions = (data) => {
    const result = [];
    if(data){
        for (const item of data) {
            result.push({ id: item.id, label: item.type });
        }
    }
    return result;
};

const channelTypeOptions = (data) => {
    const result = [];
    if(data){
        for (const item of data) {
            result.push({ id: item.id, label: item.name });
        }
    }
    return result;
};

const updatedFieldValueData = (state,action) => {
    const {
        index, i, value 
    } = action.payload;
    const { fieldValueData } = state.fileSetup;
    const updatedFieldValue = fieldValueData.map((item, idx) => {
        if (idx === index) {
            const updatedFields = item.filesetupfields.map((field, fieldIdx) => {
                if (fieldIdx === i) {
                    return {
                        ...field,
                        filesetupfieldmapping: {
                            ...field.filesetupfieldmapping,
                            value: value
                        }
                    };
                }
                return field;
            });
            return {
                ...item,
                filesetupfields: updatedFields
            };
        }
        return item;
    });
    return updatedFieldValue;
};

const getPartnerApiData = (data) =>{
    if(data){
        const result = [];
        data.map((item) => {
            result.push({
                partnerId: item.campaign_integration_partner_id,
                apiKey: item.api_key
            });
        });
        return result;
    }
};

export const { actions } = adminSettings;
export default adminSettings.reducer;